module.exports = __webpack_public_path__ + "static/img/help_share_img.837bb01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/new_years_day/popup/help_share_img.png
// module id = xoLo
// module chunks = 1